export const firebaseConfig = {
  apiKey: "AIzaSyB5SmzwfRPTZUM3qfQCPo1pqhz8sHMrTgc",
  authDomain: "titanium-diode-418307.firebaseapp.com",
  projectId: "titanium-diode-418307",
  storageBucket: "titanium-diode-418307.appspot.com",
  messagingSenderId: "451315736773",
  appId: "1:451315736773:web:98831b2c30eafe37b1d0ac",
} as const;
